import styled from 'styled-components';
import {defaultTheme} from "../../styles/themes/default";

interface ContainerProps {
    active: boolean
}

export const Container = styled.div<ContainerProps>`
  .react-datepicker__input-container{
    font-family: "La Nord", sans-serif !important;
    span{
      display: none;
    }
    input{
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 12px;
      background: ${(props:ContainerProps) => props.active ? defaultTheme.accentLightest : defaultTheme.grayBackground};
      color: ${(props:ContainerProps) => props.active ?  defaultTheme.accent : defaultTheme.grayDark};
      font-weight: 500;
      font-size: 14px;
      border-radius: 8px;
      transition: all 300ms ease-in-out;
      cursor: pointer;
      border: unset;
      max-width: 120px;
    }
  }
  .react-datepicker{
    display: flex;
    flex-direction: column;
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    color: ${({theme}) => theme.gray};
    background: ${({theme}) => theme.white};
    border-radius: 6px;
    border: 1px solid ${({theme}) => theme.grayDivider};
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.06);
    padding: 8px;
  }
  .react-datepicker__navigation{
    margin-top: 10px;
  }
  .react-datepicker__triangle{
    display: none;
  }
  .react-datepicker__aria-live{
    display: none;
  }
  .react-datepicker__month-container{
    .react-datepicker__header{
      background: ${({theme}) => theme.white};
      border: unset;
      font-size: 14px;
      font-weight: 500;
      color: ${({theme}) => theme.gray};
    }
    .react-datepicker-year-header{
      background: ${({theme}) => theme.white};
      
    }
    .react-datepicker__month-text{
      padding: 12px 20px;
      text-align: center;
      :hover{
        background: ${({theme}) => theme.grayLightest};
      }
    }
    .react-datepicker__month-text--keyboard-selected{
      border-radius: 4px;
      background: ${({theme}) => theme.grayLightest};
      color: ${({theme}) => theme.grayDark};
    }
  }
`
